/**
 * ICER Health watermark.
 *
 * Renders the full ICER Health wordmark+figure logo as a faint, fixed,
 * centered background element that sits BEHIND every page. Doesn't
 * intercept clicks (`pointer-events-none`), doesn't take part in
 * layout (`fixed`), and uses very low opacity so it never competes
 * with foreground content.
 *
 * Drop the asset at:
 *   web/public/branding/icer-health-watermark.png
 *
 * If the file isn't there, the watermark hides itself silently —
 * nothing breaks while the asset is being prepared.
 */
import { useState } from 'react'

export default function Watermark() {
  const [failed, setFailed] = useState(false)
  if (failed) return null
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 flex items-center justify-center overflow-hidden print:hidden"
    >
      <img
        src="/branding/icer-health-watermark.png"
        alt=""
        onError={() => setFailed(true)}
        // Tuning rationale:
        //   * width capped — never bigger than the body content area
        //     on a 13-15" laptop so the watermark stays "behind the
        //     content" rather than "framing the content".
        //   * opacity 0.10 — feels more present than 0.05 on the
        //     slate-50 app backdrop (white cards still occlude it
        //     entirely, so it shows only in the gaps between cards
        //     and at the edges of the page where it should).
        //   * grayscale 1 + brightness 0.4 — drains the orange/blue
        //     ink to a warm neutral grey. This is what makes the
        //     watermark feel "embossed / printed" instead of
        //     "translucent decal". Works on any light surface.
        style={{
          width: 'min(60vw, 700px)',
          maxHeight: '70vh',
          opacity: 0.10,
          objectFit: 'contain',
          transform: 'rotate(-10deg)',
          filter: 'grayscale(1) brightness(0.4)',
          userSelect: 'none',
        }}
      />
    </div>
  )
}
